import React, { useState } from 'react'
import { Stack, TextField, Typography } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import api from '../../../services/api'
import * as yup from 'yup'
import { translate } from '../../../i18n'
import { Button } from '../../../components/Button'
import Iconify from '../../../components/Iconify'
import { useTheme } from '@mui/material/styles'
import { useAppDispatch } from 'redux/hooks'
import { showMessage } from 'redux/reducers/snackbar/snackbar.actions'

const forgotAddEmailSchema = yup.object({
  username: yup
    .string()
    .trim()
    .required(() => translate('forgot.required.username'))
    .email(() => translate('forgot.email.username'))
})

interface ForgotAddEmailProps {
  username: string
}

export interface ForgotAddEmailFormProps {
  onSuccess: Function
}
export default function ForgotAddEmailForm ({ onSuccess }: ForgotAddEmailFormProps) {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<ForgotAddEmailProps>({
    resolver: yupResolver(forgotAddEmailSchema)
  })

  const handleSend = async (dataPost: ForgotAddEmailProps) => {
    setLoading(true)

    try {
      const result = await api.post('/users/forgot-password',
        { username: dataPost.username },
        { headers: { 'Content-Type': 'application/json' } })
      if (result) {
        dispatch(showMessage({ message: `${t('account.forgot_password_success')}` }))
        onSuccess(dataPost.username)
      }
    } catch (e) {
      dispatch(showMessage({ message: `${t('general.error')}`, type: 'error' }))
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Stack alignItems="center" spacing={3}>
        <Iconify icon="material-symbols:lock-outline" width={80} color={theme.palette.primary.main} />
        <Typography variant="h3">{t('forgot.title')}</Typography>
        <Typography variant="body1" textAlign="center">{t('forgot.subtitle')}</Typography>
      </Stack>
      <Stack mb={2} mt={2}>
        <Controller
          control={control}
          name="username"
          render={({ field: { onChange } }) => (
            <TextField
              placeholder={t<string>('forgot.field.username.placeholder')}
              label={t<string>('forgot.field.username.label')}
              onChange={onChange}
              autoCapitalize="none"
              helperText={errors.username?.message}
              error={errors.username?.message !== undefined}
            />
          )} />
      </Stack>
      <Stack>
        <Button
          title={t('forgot.btn.reset')}
          isLoading={loading}
          onClick={handleSubmit(handleSend)}
        />
      </Stack>
    </>
  )
}
